<script setup>
import { ref } from '@vue/reactivity'
import FileInput from '../Forms/FileInput.vue'
import SubmitButtonComponent from './SubmitButtonComponent.vue'
import useApi from '../../Services/useApi'
import useNotification from '../../Services/useNotification'
import { Inertia } from '@inertiajs/inertia'

const api = useApi()
const notificate = useNotification()
const file = ref(null)
const showForm = ref(false)

const uploadFile = async()=>{
    // form data
    let fileData = new FormData();
    fileData.append('file', file.value);
    api.uploadClassificationExcel(fileData).then(response=>{
        console.log(response)
        notificate.success('Guardado con exito')
        Inertia.reload()
    })
}
</script>

<template lang="">
    <div>
        <button
            class="px-4 py-1 border rounded-2xl border-enriqueto_green hover:bg-light_green hover:text-white"
            @click="showForm = true"
        >
            Subir excel
        </button>
        <div v-if="showForm" class="my-8 w-96">
            <form action="" class="" v-on:submit.prevent="uploadFile">
                <FileInput v-model="file" accept=".xls,.xlsx" />
                <SubmitButtonComponent value="Subir"/>
            </form>
        </div>  
        
    </div>
    
</template>

<style lang="">
    
</style>